document.addEventListener("DOMContentLoaded", function () {
    // Find all carousel instances
    document.querySelectorAll('.carousel').forEach(function(carousel) {
        // Scope selectors to current carousel instance
        const carouselInner = carousel.querySelector('.carousel-inner');
        const items = carouselInner.querySelectorAll('.item');
        const totalItems = items.length;
        let shiftWidth = items[0] ? items[0].clientWidth : 0;
        
        const totalWidth = Array.from(items).reduce((total, item) => total + item.clientWidth, 0);
        const carouselWidth = carouselInner.offsetWidth;
        
        const prevButton = carousel.querySelector('.carousel-control-prev');
        const nextButton = carousel.querySelector('.carousel-control-next');
        
        const activeIndex = Array.from(items).findIndex(item => item.classList.contains('active'));
        let currentIndex = activeIndex !== -1 ? activeIndex : 0;
        
        if (window.innerWidth > 767) {
            if (activeIndex === totalItems - 1) {
                currentIndex = Math.max(0, activeIndex - 2);
            } else if (activeIndex === totalItems - 2) {
                currentIndex = Math.max(0, activeIndex - 1);
            }
        }
        
        let prevTranslate = -currentIndex * shiftWidth;
        let currentTranslate = prevTranslate;
        
        const isNonTouch = window.matchMedia('(hover: hover)').matches;
        
        function updateButtonVisibility() {
            if (isNonTouch) {
                prevButton.style.display = currentIndex === 0 ? 'none' : 'block';
                nextButton.style.display = (currentIndex * shiftWidth) >= (totalWidth - carouselWidth) ? 'none' : 'block';
            } else {
                prevButton.style.display = 'block';
                nextButton.style.display = 'block';
            }
        }
        
        function updateCarousel() {
            let offset = -currentIndex * shiftWidth;
            carouselInner.style.transition = 'transform 0.5s ease';
            carouselInner.style.transform = `translateX(${offset}px)`;
            prevTranslate = offset;
            currentTranslate = prevTranslate;
            updateButtonVisibility();
        }
        
        function navigate(direction) {
            currentIndex += direction;
            
            if (currentIndex < 0) {
                currentIndex = 0;
            } else if ((currentIndex * shiftWidth) >= (totalWidth - carouselWidth)) {
                currentIndex = Math.ceil((totalWidth - carouselWidth) / shiftWidth);
            }
            
            updateCarousel();
        }
        
        updateCarousel(); // Initialize for each carousel
        
        prevButton.addEventListener('click', function () {
            navigate(-1);
        });
        
        nextButton.addEventListener('click', function () {
            navigate(1);
        });
        
        let isDragging = false, startX;
        
        function startDrag(e) {
            isDragging = true;
            startX = e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
            carouselInner.classList.add('grabbing');
        }
        
        function drag(e) {
            if (!isDragging) return;
            const currentX = e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
            const diffX = currentX - startX;
            let newTranslate = prevTranslate + diffX;
            
            if (newTranslate > 0) {
                newTranslate = 0;
            } else if (Math.abs(newTranslate) > totalWidth - carouselWidth) {
                newTranslate = -(totalWidth - carouselWidth);
            }
            
            currentTranslate = newTranslate;
            carouselInner.style.transition = 'none';
            carouselInner.style.transform = `translateX(${currentTranslate}px)`;
        }
        
        function endDrag() {
            isDragging = false;
            carouselInner.classList.remove('grabbing');
            const dragDistance = currentTranslate - prevTranslate;
            const dragPercentage = Math.abs(dragDistance) / shiftWidth;
            
            if (dragPercentage > 0.2) {
                if (dragDistance > 0) {
                    currentIndex = currentIndex > 0 ? currentIndex - 1 : 0;
                } else {
                    currentIndex = ((currentIndex + 1) * shiftWidth) >= (totalWidth - carouselWidth) ? Math.ceil((totalWidth - carouselWidth) / shiftWidth) : currentIndex + 1;
                }
            }
            
            updateCarousel();
        }
        
        carouselInner.addEventListener('touchstart', startDrag);
        carouselInner.addEventListener('touchmove', drag);
        carouselInner.addEventListener('touchend', endDrag);
        carouselInner.addEventListener('mousedown', startDrag);
        window.addEventListener('mousemove', drag);
        window.addEventListener('mouseup', endDrag);
        
        carouselInner.addEventListener('dragstart', (e) => e.preventDefault());
        carouselInner.addEventListener('selectstart', (e) => e.preventDefault());
    });
});
